import {
  getString,
  getLeoUuid,
  LeoUUID,
  getLeoTimestamp,
  LeoTimestamp,
} from "@surya-digital/leo-ts-types";

export interface GetProjectBOUsersPaginationResponseDTO {
  name: string;
  emailAddress: string;
  boUserId: string;
  projectId: string;
  role: string;
  addedOn: string;
}

export class GetProjectBOUsersPaginationResponse {
  readonly isGetProjectBOUsersPaginationResponseGetProjectBOUsersPaginationResponse: boolean = true;

  readonly name: string;
  readonly emailAddress: string;
  readonly boUserId: LeoUUID;
  readonly projectId: LeoUUID;
  readonly role: string;
  readonly addedOn: LeoTimestamp;


  constructor(
  name: string, 
  emailAddress: string, 
  boUserId: LeoUUID, 
  projectId: LeoUUID, 
  role: string, 
  addedOn: LeoTimestamp
  ) {
    GetProjectBOUsersPaginationResponse.validateName(name);
    this.name = name;
    GetProjectBOUsersPaginationResponse.validateEmailAddress(emailAddress);
    this.emailAddress = emailAddress;
    this.boUserId = boUserId;
    this.projectId = projectId;
    GetProjectBOUsersPaginationResponse.validateRole(role);
    this.role = role;
    this.addedOn = addedOn;
  }

  static fromDTO(dto: GetProjectBOUsersPaginationResponseDTO): GetProjectBOUsersPaginationResponse {
    const name = getString(dto, "name", InvalidGetProjectBOUsersPaginationResponseNameError);
    const emailAddress = getString(dto, "emailAddress", InvalidGetProjectBOUsersPaginationResponseEmailAddressError);
    const boUserId = getLeoUuid(dto, "boUserId", InvalidGetProjectBOUsersPaginationResponseBoUserIdError);
    const projectId = getLeoUuid(dto, "projectId", InvalidGetProjectBOUsersPaginationResponseProjectIdError);
    const role = getString(dto, "role", InvalidGetProjectBOUsersPaginationResponseRoleError);
    const addedOn = getLeoTimestamp(dto, "addedOn", InvalidGetProjectBOUsersPaginationResponseAddedOnError);
    return new GetProjectBOUsersPaginationResponse(
      name,
      emailAddress,
      boUserId,
      projectId,
      role,
      addedOn
    );
  }

  toDTO(): GetProjectBOUsersPaginationResponseDTO {
    const dto: GetProjectBOUsersPaginationResponseDTO = {
        name: this.name,
        emailAddress: this.emailAddress,
        boUserId: this.boUserId.toDTO(),
        projectId: this.projectId.toDTO(),
        role: this.role,
        addedOn: this.addedOn.toDTO()
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.trim().length === 0) {
      throw new InvalidGetProjectBOUsersPaginationResponseNameNonEmptyError(
        `Attribute name cannot be an empty string.`
      );
    }
  }
  private static validateEmailAddress = (emailAddress: string): void => {
    if(emailAddress.trim().length === 0) {
      throw new InvalidGetProjectBOUsersPaginationResponseEmailAddressNonEmptyError(
        `Attribute emailAddress cannot be an empty string.`
      );
    }
  }
  private static validateRole = (role: string): void => {
    if(role.trim().length === 0) {
      throw new InvalidGetProjectBOUsersPaginationResponseRoleNonEmptyError(
        `Attribute role cannot be an empty string.`
      );
    }
  }
  
}

GetProjectBOUsersPaginationResponse.prototype.toString = function toString(): string {
  return `GetProjectBOUsersPaginationResponse(name='${this.name}',emailAddress='${this.emailAddress}',boUserId='${this.boUserId}',projectId='${this.projectId}',role='${this.role}',addedOn='${this.addedOn}')`;
};

export class InvalidGetProjectBOUsersPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseError";
  }
}
export class InvalidGetProjectBOUsersPaginationResponseNameError extends InvalidGetProjectBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseNameError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseNameNonEmptyError extends InvalidGetProjectBOUsersPaginationResponseNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseNameNonEmptyError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseEmailAddressError extends InvalidGetProjectBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseEmailAddressError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseEmailAddressNonEmptyError extends InvalidGetProjectBOUsersPaginationResponseEmailAddressError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseEmailAddressNonEmptyError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseBoUserIdError extends InvalidGetProjectBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseBoUserIdError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseProjectIdError extends InvalidGetProjectBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseProjectIdError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseRoleError extends InvalidGetProjectBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseRoleError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseRoleNonEmptyError extends InvalidGetProjectBOUsersPaginationResponseRoleError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseRoleNonEmptyError";
  }
}

export class InvalidGetProjectBOUsersPaginationResponseAddedOnError extends InvalidGetProjectBOUsersPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectBOUsersPaginationResponseAddedOnError";
  }
}
